import React from 'react'
import ModalWTN from 'components/generic/ModalWTN'
import ConfidenceModalContent from 'components/search/CombinedRatingFilter/ConfidenceModalContent'
import { useModalDispatch } from 'hooks/use-modal'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import modalStyles from '../../search/CombinedRatingFilter/combinedRatingFilter.module.scss'

export const CONFIDENCE_MODAL_ID = 'player-profile-confidence-modal'

const ConfidenceModal = () => {
  const { t } = useTranslation(['strCommonUI', 'strFilters'])
  const { modalActions, modalDispatch } = useModalDispatch(CONFIDENCE_MODAL_ID as never)

  return (
    <ModalWTN
      widgetElId='player-profile'
      modalId={CONFIDENCE_MODAL_ID}
      btnAlignment='right'
      btnSecondary={{
        text: t('button.close', { ns: 'strCommonUI' }),
        onClick: () => {
          modalDispatch(modalActions.closeModal())
        },
      }}
      textHeader={t('confidenceModal.title', { ns: 'strFilters' })}
      className={cx(modalStyles.infoModalConfidence, modalStyles.override)}
    >
      <ConfidenceModalContent />
    </ModalWTN>
  )
}

export default ConfidenceModal
